export const deleteSmscAccount = (builder) => ({
    deleteSmscAccount: builder.mutation({
      query: (body) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/delete_smsc',
          method: 'DELETE',
          body: body,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  
  